/**
 * User permission definitions for granular access control
 * These permissions can be granted to users in addition to their base userType
 */
export enum UserPermission {
  /**
   * Access to the notifications builder interface
   * Allows creating and managing scheduled notification templates
   */
  CanAccessNotificationsBuilder = 'canAccessNotificationsBuilder',
  CanAccessReports = 'canAccessReports',
  /**
   * Permission to alter data. Internal users lacking it are read-only: they see every
   * retailer's data but cannot write. Granted to all Internal users by migration 393.
   */
  InternalCanWrite = 'internalCanWrite',
}

/**
 * Type for user permissions object stored in UserAccount.permissions JSONB column
 */
export type UserPermissions = {
  [UserPermission.CanAccessNotificationsBuilder]?: boolean;
  [UserPermission.CanAccessReports]?: boolean;
  [UserPermission.InternalCanWrite]?: boolean;
}

/**
 * Helper function to check if user has a specific permission
 */
export function hasUserPermission (
  permissions: UserPermissions | null | undefined,
  permission: UserPermission,
): boolean {
  if (!permissions) return false;
  return permissions[permission] === true;
}

